//export const API_BASE_URL = `https://${process.env.REACT_APP_HARNESS_ALERT_ENVIRONMENT === "true" ? process.env.REACT_APP_API_ADDRESS : process.env.REACT_APP_TEST_API_ADDRESS}/api`;
export const API_BASE_URL = `${process.env.REACT_APP_HARNESS_ALERT_ENVIRONMENT === "true" ? process.env.REACT_APP_API_ADDRESS : process.env.REACT_APP_TEST_API_ADDRESS}`;

//export const API_BASE_URL = `/api`;

export const RESPONSE_CODE = {
  SUCCESS: 200,
  ERROR: 500,
  BAD_REQUEST: 400,
};
